<div>
    <button  type="button" mat-button class="addnewBtn" (click)="showAddEndClient = !showAddEndClient" class="addnewbutton">Add New End Client</button>
    <form #f="ngForm">
        <div *ngIf="showAddEndClient" class="md-input-container">
            <mat-form-field class="mat-form-withtooltip">
               
                <input type="text"
                placeholder="End Client"
                aria-label="Number"
                matInput name="endclient"
                 #myControl
                       (input)="loadItems()"
                 [(ngModel)]="name"
                [matAutocomplete]="auto">
             <mat-autocomplete  #auto="matAutocomplete" (optionSelected)="loadItems()">
               <mat-option *ngFor="let item of allEndClientList" [value]="item">
                 {{item}}
               </mat-option>
             </mat-autocomplete>
            </mat-form-field>
        </div>
        <div *ngIf="showAddEndClient">
            <button type="button" class="addnewbutton" (click)="addEndClient($event)"
             mat-button [disabled]="!name">Save New End Client</button>
        </div>
    </form>
</div>
